<!--
  @Author: MIYONGLE
  @Desc: 致力于助力每一个优秀的公司
  @Date: 2021-04-20
-->
<template>
  <div>
    <div class="pc-form-main">
      <!--背景-->
      <div class="fullwidth-bg-img" style="z-index: -1"></div>

      <!--表单-->
      <div class="min-width-pc">
        <div class="pc-form">
          <!-- 插槽 -->
          <slot></slot>

          <el-form
            class="pc-form-con"
            :rules="formRules"
            ref="paramAppointment"
            :model="paramAppointment"
          >
            <el-form-item class="pc-form-line" prop="name">
              <p>
                <img src="../../static/pc/ic_home_name.png" alt="灵活用工" />
              </p>
              <el-input
                type="text"
                v-model="paramAppointment.name"
                placeholder="请输入您的姓名"
                class="pc-form-item"
              ></el-input>
            </el-form-item>
            <el-form-item class="pc-form-line" prop="phone">
              <p>
                <img src="../../static/pc/ic_home_iphone.png" alt="灵活用工" />
              </p>
              <el-input
                type="text"
                v-model="paramAppointment.phone"
                placeholder="请输入您的电话号码"
                class="pc-form-item"
              ></el-input>
            </el-form-item>
            <el-form-item class="pc-form-line" prop="companyName">
              <p>
                <img src="../../static/pc/ic_home_company.png" alt="灵活用工" />
              </p>
              <el-input
                type="text"
                v-model="paramAppointment.companyName"
                placeholder="请输入您的公司全称"
                class="pc-form-item"
              ></el-input>
            </el-form-item>
            <el-form-item class="pc-form-line" prop="provinceCity">
              <p>
                <img
                  src="../../static/pc/icon_input_position.png"
                  alt="灵活用工"
                />
              </p>
              <el-cascader
                v-model="paramAppointment.provinceCity"
                :options="optionsProvinceOrCity"
                placeholder="请选择公司所在位置"
                @change="handleChange"
                @expand-change="expandChange"
                ref="cascader"
                :append-to-body='false'
              ></el-cascader>
            </el-form-item>
            <el-button
              class="pc-form-btn"
              @click="immediatelySub('paramAppointment')"
              >立即预约</el-button
            >
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import { postMakeAppoint, postFindProvinceOrCity } from "../service/apis";
import { HTTP_CODE } from "../service/axios_constants";
import { jumpAnchorPoint, checkNull } from "../filters/filters";

export default {
  components: {},
  props: {
    source: String,
  },

  data() {
    return {
      //校验
      formRules: {
        name: [{required: true,message: "姓名不能为空",trigger: ["blur", "change"]}],
        phone: [{ required: true, message: "电话不能为空", trigger: "blur" }],
        companyName: [{ required: true, message: "公司不能为空", trigger: "blur"}],
        provinceCity:[{required: true, message: '公司所在城市不能为空', trigger: 'blur'},]
      },
      optionsProvinceOrCity: [],//公司所在城市区选择
      optionsProvinceOrCityTemp: [],

      paramAppointment: {
        name: "",
        phone: "",
        companyName: "",
        companyName2: [],
        source: "",
        // sites:''
        bdVid: "", //百度埋点
        province:'',
        city:'',
        provinceCity:'',
      },
      clickDisabled: false, // 禁止重复点击预约
    };
  },

  created() {
    this.paramAppointment.source = this.source;
    this.paramAppointment.bdVid = this.$route.query.bd_vid;
    //  渠道等信息，整个参数路径传入，让运营能够自主发挥，自主匹配各参数所代表的意义
    // let type = window.location.hash.split('?')[1] || getSession('channelType');
    this.xhrPostFindProvinceOrCity();
  },

  methods: {
    //xhr--立即预约
    immediatelySub() {
      if (this.clickDisabled) {
        return;
      }
      // this.paramAppointment.sites = getSession('channelType')
      this.$refs["paramAppointment"].validate((valid) => {
        if (valid) {
          this.clickDisabled = true;
          postMakeAppoint(this.paramAppointment).then((res) => {
            this.clickDisabled = false;
            if (res.statusCode === HTTP_CODE.suc) {
              this.$refs["paramAppointment"].resetFields();
              this.paramAppointment.provinceCity = ''
              MessageBox("预约成功！", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                confirmButtonClass: "btnFullColor",
              });
              if (!checkNull(document.getElementById("carouselCon"))) {
                jumpAnchorPoint("#carouselCon");
              }
            }
          });
        }
      });
    },

    handleChange(value) {
      this.paramAppointment.province = this.$refs['cascader'].getCheckedNodes()[0].pathLabels[0]
      this.paramAppointment.city = this.$refs['cascader'].getCheckedNodes()[0].pathLabels[1]
      // this.paramAppointment.provinceCity = [this.paramAppointment.province,this.paramAppointment.city]
      console.log('yuyu',this.paramAppointment.provinceCity);
    },

    expandChange(value) {
      console.log('yuyu');
      this.xhrPostFindProvinceOrCity(value[0]);
    },

    
    // xhr----查询省市接口
    xhrPostFindProvinceOrCity(value) {
      let paramQuery = {
        provinceId: value,
      };
      postFindProvinceOrCity(paramQuery).then((res) => {
        if (res.statusCode === HTTP_CODE.suc) {
          if(checkNull(paramQuery.provinceId)){
            this.optionsProvinceOrCityTemp = res.data;
            for (let type of this.optionsProvinceOrCityTemp) {
              type.value = type.code;
              type.label = type.name;
              type.children = [];
            }
          }else{
            for(let item of this.optionsProvinceOrCityTemp){
              if(item.code == value){
                item.children = res.data
                for(let val of item.children){
                  val.value = val.code;
                  val.label = val.name;
                }
              }
            }
          }
          this.optionsProvinceOrCity = JSON.parse(JSON.stringify(this.optionsProvinceOrCityTemp))
        }
      });
    },
  },
};
</script>

<style>
.pc-form-con .el-input {
  height: 60px;
  line-height: 60px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
}
.pc-form-con .el-input__inner {
  padding-left: 50px;
  border: none;
  box-sizing: border-box;
  height: initial;
  line-height: initial;
}
.pc-form-con .el-form-item {
  margin-bottom: 20px;
}
.pc-form-item input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #717171;
}
.pc-form-item input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #717171;
}
.pc-form-item input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #717171;
}
.pc-form-item input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #717171;
}

.pc-form .el-input__suffix{
  display: none;
}
</style>

<style scoped="scoped" lang="scss">
//致力于优秀公司
.pc-form-main {
  width: 100%;
  margin-bottom: 100px;
  .pc-form-bg {
    background: url("../../static/pc/img_bg.png") no-repeat top center;
    background-size: cover;
    width: 100%;
    height: 360px;
    padding: 0 10px;
  }
  .pc-form {
    width: 100%;
    height: 608px;
    box-shadow: 0 20px 60px 0 rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    background: #ffffff;
    margin-top: -230px;
    .pc-form-img {
      padding-top: 60px;
      padding-bottom: 10px;
    }
    .pc-form-con {
      width: 520px;
      margin: 0 auto;
      margin-top: 16px;
      .pc-form-line {
        position: relative;
        p {
          width: 20px;
          height: 20px;
          position: absolute;
          z-index: 99;
          left: 20px;
          top: 15px;
          img {
            width: 100%;
          }
        }
      }
      .pc-form-btn {
        background: #1985ff;
        border-radius: 30px;
        font-size: 18px;
        color: #ffffff;
        width: 200px;
        height: 48px;
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pcForm.vue